import React from "react";
import { useRouteError } from "react-router-dom";

const ErrorPage = () => {
  const error = useRouteError();
  console.error(error);

  return (
    <div className="flex flex-col justify-center items-center h-screen bg-red-50">
      <h1 className="text-4xl font-bold text-red-500">Unexpected Application Error!</h1>
      <p className="mt-4 text-lg text-gray-700">Something went wrong.</p>
      {error?.message && (
        <pre className="mt-4 p-4 bg-gray-100 rounded-lg shadow-lg">
            <p className="font-bold text-xl">May be api free quota limit exceeded.</p>
          {error.message}
        </pre>
      )}
    </div>
  );
};

export default ErrorPage;
